export default "__VITE_ASSET__DXl2$WUv__"